export var E_UserRole;
(function (E_UserRole) {
    E_UserRole[E_UserRole["General"] = 0] = "General";
    E_UserRole[E_UserRole["Admin"] = 1] = "Admin";
})(E_UserRole || (E_UserRole = {}));
export var E_UserStatus;
(function (E_UserStatus) {
    E_UserStatus["ACTIVE"] = "ACTIVE";
    E_UserStatus["FAKE_ACTIVE"] = "FAKE_ACTIVE";
    E_UserStatus["INACTIVE"] = "INACTIVE";
    E_UserStatus["PENDING"] = "PENDING";
    E_UserStatus["DISABLED"] = "DISABLED";
    E_UserStatus["BLOCKED"] = "BLOCKED";
    E_UserStatus["EXPIRED"] = "EXPIRED";
    E_UserStatus["NO_STATUS"] = "NO_STATUS";
    E_UserStatus["BLACK"] = "BLACK";
})(E_UserStatus || (E_UserStatus = {}));
// 需要从后端动态获取, 这里只是用于定义
export var E_AccountType;
(function (E_AccountType) {
    E_AccountType["STANDARD"] = "STANDARD";
    E_AccountType["TRIAL"] = "TRIAL";
    E_AccountType["FREE"] = "FREE";
})(E_AccountType || (E_AccountType = {}));
